<template>
  <div id="app" class="app">
        <div class="main" id="main">
            <div class="containerMain" id="containerMain">
              <div v-show="headerShown">
              <div id="header" v-if="isAres" style="background-color:#EA3132;">
                <img  src="@/assets/img/logo-juro.png" width="99" alt="Juro" style="display: block;margin: 0 auto;padding: 10px 0 14px"><hr style="margin-bottom:-0.5rem;margin-top:0px;">
              </div>
              <div id="header" v-else>
                <div style="padding-top:1px;">
                  <img src="@/assets/img/header-logo-20.png" alt="Telekom" style="display: block;margin: 10px auto;height:26px;"><hr style="margin-bottom:-0.5rem">
                </div>
              </div>
              </div>
                  <router-view v-if="!appOff" />

                  <div v-if="appOff" id="dashboard">
                    <div class="row">
                        <div class="large-12 medium-12 small-12 columns text-center"><p></p>
                            <p v-html="states.offText"></p>
                        </div>
                    </div>
                  </div>
            </div>
        </div>
      <div id="footer" v-if="footerFinal">
          <div class="app-banner">
              <div class="banner-left">
                  <div class="text-banner">{{oneappText}} <span class="magenta">cez appku</span></div>
                  <a class="button-green-small-bn" href="https://telekomsk.page.link/JioD">STIAHNUŤ APPKU</a>
              </div>
              <div class="banner-right">
                  <img class="logo-small" src="//m.telekom.sk/appgui/graphics/app_popup_logo.png">
              </div>
          </div>
      </div>
  </div>
</template>
<script>
import MobileDetect from '@/assets/js/mobile-detect.min'
import moment from 'moment'

export default {
  name: 'App',
  data() {
    return {
      footer_banner: false,
      msisdn: '',
      productdetail: {},
      states: {
        viewAllow: false, showWait: true, showFail: false, offText: "ODSTÁVKA", headerShown: this.$store.state.headerShown
      },
      oneappText: "",
      MobileDetect: MobileDetect,
      md: new MobileDetect(window.navigator.userAgent),
      moment: moment,
      menuRender: function() {}
    }
  },
  mounted: function() {
    const that = this;
    function renderMenu (mdata) {		
      $('#app').prepend("<div class='settings' id='settings'>"+
          "<div class='container' id='container'>"+
            "<div id=main-menu style='font-family:TeleGrotesk, Arial, Helvetica, sans-serif !important;'>"+mdata+"</div></div></div>"); 
      $('#header').prepend("<a onclick='openMain(); return false;' id='menutoggle'></a>")
      $('#menutoggle').show()
      global.lastWidth = $(window).width()
      global.mainOpen = 0
      setDisplaySize()
      $(".main, .settings").show()
      var msisdnRemoteSpan = document.querySelector("#main-menu .mm-heading:nth-child(1) span")
      var msisdnTextSpan = document.getElementById('msisdnTextSpan')
      msisdnRemoteSpan.replaceWith(msisdnTextSpan)
      var currRouteName = that.$route.name
      $.each(document.querySelectorAll('#main-menu li > a'), function() {	
      var actual = this.innerHTML;
      if (actual == "Balíčky") {
        actual = 'Balicky';
      }			
      if (currRouteName == 'Home')	{
        currRouteName = 'Kredit'
      }
      if (actual == currRouteName) { 
          this.parentNode.classList.add('mm-active')
      } else {
          this.parentNode.classList.remove('mm-active')
      }
      })     
    }
    async function menuRender() {
      var msisdn = ' ...'
        that.$http.get('//m.telekom.sk/menu/export?type=prepaid&msisdn='+msisdn)
          .then(function (resp) {
            var tElem = document.createElement('div');
            tElem.innerHTML = resp.data;
            const listItems = tElem.querySelector('ul').children;
            const listArray = Array.from(listItems);
            listArray.forEach((item) => {
              if (item.getElementsByTagName('a')[0]) {
                var ae = item.getElementsByTagName('a')[0];
                if ((ae.href.indexOf('/kredit') !== -1) || (ae.href.indexOf('/profil') !== -1) || (ae.href.indexOf('balicky') !== -1)) {
                  var celem = ae.href.split("/");
                  ae.href = "#"+celem[celem.length-1]
                }
                if (ae.href.indexOf('spending') !== -1) {
                  var celem = ae.href.split("/");
                  ae.href = "#travel"
                }
              }
            });
          renderMenu(tElem.innerHTML);        
        })
        .catch(function(er){
          console.info(er);
        });
    }
    if ((window.location.search.indexOf('nomenu=1') == -1) && (window.location.pathname.indexOf('/viac-dat') == -1)) {
      menuRender()
    }
    this.menuRender = menuRender;
  window.addEventListener("resize", function(){
    setTimeout(function(){
      $(document).foundation('slider', 'reflow')      
      that.checkResize(that.md)
    }, 600)
  })

  this.checkResize(this.md)

  if ((this.$route.name == 'Kredit') || (this.$route.name == 'Home')) {
    this.oneappText = "Dobíjajte si kredit výhodne";
  } else {
    this.oneappText = "Dokupujte si dáta pohodlnejšie";
  }
},
methods: {
  checkResize: function(md) {
    var getResize = document.getElementById('containerMain')
    if (((this.$route.name == 'Kredit') || (this.$route.name == 'Home') || (this.$route.name == 'Profil')) && (window.outerWidth < 640)){      
        if ((md.os() == 'AndroidOS') && (md.version('Android') >= 7)) {
            this.footer_banner = true;
            if (this.footerFinal) {
              getResize.style.paddingBottom = '100px'
            }
        }
        if (md.os() == 'iOS') {
            this.footer_banner = true;
            if (this.footerFinal) {
              getResize.style.paddingBottom = '100px'
            }
        }
    } else {
      this.footer_banner = false;
      getResize.style.paddingBottom = '0'
    }
  }
},
created: function() {
},
computed: {
  appOff: function() {
    if (this.$store.state.tplData.general !== undefined) {
      if ((this.$store.state.tplData.general.appOff === "true") && (!this.$route.query.override == "1")) {
        this.states.offText = this.$store.state.tplData.general.offText
        return true
      } else {
        return false
      }
    }
  },
  footerFinal: function() {
    if ((this.footer_banner === true) && (window.location.search.indexOf('nomenu=1') == -1) ) {
      return true
    }
  },
  isAres: function() {
    if (this.$store.state.isAres === false) {
      this.menuRender()      
      return false
    } else if ((this.$route.name == 'ViacData' || this.$route.name == 'Data') && (this.$store.state.isAres === true)) {
      return true 
    } else {
      return false
    }
  },
  headerShown: function() {
    return this.$store.state.headerShown
  }
},
watch:{
  $route (to, from){
    if (to.hash.length > 2) {
      this.$router.replace('/'+to.hash.substring(1))
      if (global.mainOpen === 0) {
        if ($("#app").width() < 600){
          openMain()
        }
      }
    }

    if ((to.hash) === '') {
      this.checkResize(this.md)
    }    

    if ((to.name == 'Kredit') || (to.name == 'Home')) {
      this.oneappText = "Dobíjajte si kredit výhodne";
    } else {
      this.oneappText = "Dokupujte si dáta pohodlnejšie";
    }

    $.each(document.querySelectorAll('#main-menu li > a'), function() {	
      var actual = this.innerHTML;
      if (actual == "Balíčky") {
        actual = 'Balicky';
      }		
    if (actual == to.name) { 
        this.parentNode.classList.add('mm-active');
    } else {
        this.parentNode.classList.remove('mm-active');
    }
    });		      
  }
}
}

</script>

<style>

@import './assets/css/main.css';

</style>
